export default {"src":"https://assets.ctr1.net/d1a32bdc1f09/_next/static/media/google.811c5c6a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};